import { Record } from "immutable";
import { DateStringNumber, Nullable } from "common/records";
import { IMetaPaginationData } from "common/records/MetaPagination";
import { checkDate } from "common/helpers/Date";

export const crmUserFromJSON = (json: Partial<ICrmUserData>): CrmUserRecord => {
  const record: ICrmUserRecord = { ...(json as any) };

  if (json.created_at) {
    record.created_at = checkDate(json.created_at);
  }

  if (json.updated_at) {
    record.updated_at = checkDate(json.updated_at);
  }

  return new CrmUserRecord(record);
};

export interface ICrmUserIndexResponse {
  crm_users: ICrmUserData[];
  meta: { pagination: IMetaPaginationData };
}

export interface ICrmUserResponse {
  crm_user: ICrmUserData;
}

export type CrmUserType =
  | "MsUser"
  | "SfUser"
  | "I360User"
  | "JnUser"
  | "SrUser"
  | "LpUser"
  | "CcUser"
  | "JpUser"
  | "HoverUser"
  | "AlUser"
  | "FmUser";

export interface ICrmUserData {
  id: number;
  user_id: Nullable<number>;
  user_email?: string;
  user_first_name?: string;
  user_last_name?: string;
  org_id: number;
  crm_id: string;
  username: Nullable<string>;
  email: Nullable<string>;
  name: string;
  active: boolean;
  type: string; //CrmUserType;
  loading?: boolean;

  created_at: DateStringNumber;
  updated_at: DateStringNumber;
}

export interface ICrmUserRecord {
  id: number;
  user_id: Nullable<number>;
  user_email: Nullable<string>;
  user_first_name: Nullable<string>;
  user_last_name: Nullable<string>;
  org_id: Nullable<number>;
  crm_id: Nullable<string>;
  username: Nullable<string>;
  email: Nullable<string>;
  name: Nullable<string>;
  active: boolean;
  type: Nullable<CrmUserType>;
  loading: boolean;
  created_at: Nullable<Date>;
  updated_at: Nullable<Date>;
}

export const defaultCrmUserProps = {
  id: 0,
  user_id: null,
  user_email: null,
  user_first_name: null,
  user_last_name: null,
  org_id: null,
  crm_id: null,
  username: null,
  email: null,
  name: null,
  active: false,
  type: null,
  loading: false,
  created_at: null,
  updated_at: null,
};

export const IntegrationUserType = {
  job_nimbus: "JnUser",
  jobprogress: "JpUser",
  companycam: "CcUser",
  improveit360classic: "I360User",
  improveit360lightning: "I360LightningUser",
};

export class CrmUserRecord extends Record<ICrmUserRecord>(defaultCrmUserProps) implements ICrmUserRecord {}
